var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import cx from 'classnames';
const SvgIconComponent = (props, ref) => ((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 24,
  fill: "none",
  viewBox: "0 0 58 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M57.266.832v23h-57v-23zm-38.02 20.73 3.935-18.511h-4.68L15.893 15.89h-.054L12.035 3.05H5.84L1.872 21.564h4.685l2.58-12.81h.055l3.88 12.81h6.175zm21.599-18.51-3.86 18.512h-4.972l1.651-7.93H27.78l-1.648 7.93H21.16L25.02 3.05h4.971l-1.461 7.083h5.877l1.464-7.083h4.972zm13.088 4.19 1.198-3.686c-1.252-.58-3.403-.82-5.693-.82-4.07 0-8.274 1.432-8.274 6.208 0 2.976 2.342 3.894 4.356 4.683 1.52.595 2.852 1.117 2.852 2.394 0 1.911-2.42 2.203-3.963 2.203-1.62 0-3.593-.425-4.574-1.062l-1.17 3.765c1.62.504 3.83.958 5.744.958 4.308 0 9.071-1.328 9.071-6.444 0-3.34-2.544-4.35-4.61-5.17-1.41-.56-2.598-1.032-2.598-2.097 0-1.49 1.597-1.778 3.565-1.778 1.834 0 3.137.4 4.096.846",
  clipRule: "evenodd"
}))))({
  ...props,
  className: cx('PA-Svg', props.className)
}, ref);
const SvgClientLogo2 = SvgIconComponent;
const ForwardRef = /*#__PURE__*/forwardRef(SvgClientLogo2);
export default ForwardRef;